(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["thank-you-member"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.aaa-ly-cus-available-p';

  const init = () => {
    const root = document.querySelector('.wacoal-thankyou');
    if (!root) return;

    const clean = (element) => {
      const text = element.textContent || '';
      const cleaned = text.replace(/\s*คะแนนรางวัลที่ใช้ได้\s*/g, ' ').trim();
      if (cleaned !== text) element.textContent = cleaned;
    };

    const bind = () => {
      const points = root.querySelectorAll(selector);
      points.forEach((element) => {
        clean(element);
        if (element.dataset.wacoalPointsCleaned === 'true') return;
        element.dataset.wacoalPointsCleaned = 'true';
        const observer = new MutationObserver(() => clean(element));
        observer.observe(element, { childList: true, characterData: true, subtree: true });
      });
      return points.length > 0;
    };

    if (!bind()) {
      const rootObserver = new MutationObserver(() => {
        if (bind()) rootObserver.disconnect();
      });
      rootObserver.observe(root, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wacoal-reward-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRewardFilters = (root) => {
      const sections = root.matches?.('.wacoal-reward-catalog')
        ? [root]
        : root.querySelectorAll('.wacoal-reward-catalog');

      sections.forEach((section) => {
        if (section.dataset.rewardFilterReady === 'true') return;

        const filters = section.querySelectorAll('[data-reward-filter]');
        const cards = section.querySelectorAll('[data-reward-category]');
        if (!filters.length || !cards.length) return;

        const applyFilter = (filter) => {
          const value = filter.dataset.rewardFilter;

          filters.forEach((item) => {
            const isActive = item === filter;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          cards.forEach((card) => {
            card.hidden = value !== 'all' && card.dataset.rewardCategory !== value;
          });
        };

        filters.forEach((filter) => {
          filter.addEventListener('click', () => applyFilter(filter));
        });

        const categories = section.querySelector('.wacoal-reward-catalog__categories');
        if (categories) {
          categories.addEventListener(
            'wheel',
            (event) => {
              if (categories.scrollWidth <= categories.clientWidth) return;
              if (Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;

              const delta =
                event.deltaMode === 1
                  ? event.deltaY * 16
                  : event.deltaMode === 2
                  ? event.deltaY * categories.clientWidth
                  : event.deltaY;
              const previousScrollLeft = categories.scrollLeft;
              categories.scrollLeft += delta;

              if (categories.scrollLeft !== previousScrollLeft) event.preventDefault();
            },
            { passive: false }
          );
        }

        const activeFilter = section.querySelector('[data-reward-filter].is-active') || filters[0];
        applyFilter(activeFilter);
        section.dataset.rewardFilterReady = 'true';
      });
    };

    initializeRewardFilters(document);
    document.addEventListener('shopify:section:load', (event) => initializeRewardFilters(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
